module.exports = __webpack_public_path__ + "static/media/wscargologo_old.f71fd7ee.png";